import { render, staticRenderFns } from "./OpenBankingIsracardAndAmexDescription.vue?vue&type=template&id=11ac28b6&scoped=true"
import script from "./OpenBankingIsracardAndAmexDescription.vue?vue&type=script&lang=js"
export * from "./OpenBankingIsracardAndAmexDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ac28b6",
  null
  
)

export default component.exports